var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-module align direction"},[_c('div',{staticClass:"login-header"},[_vm._v("当前为游客模式，权限不足请先登录")]),_c('a',{staticClass:"login",attrs:{"href":_vm.$store.state.loginURL}},[_vm._v("去登录")])])}
var staticRenderFns = []

export { render, staticRenderFns }